import { Link } from 'react-router-dom';
import { hotMovies } from '@/mocks/movies';
import { categories } from '@/mocks/categories';

export default function HeroBanner() {
  const featuredMovie = hotMovies[0];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src={featuredMovie.backdrop}
        alt="蘑菇影视 - 高清超清免费在线观看"
        title="蘑菇影视 - 4K蓝光无广告不缓冲影视平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-background-50"></div>

      <div className="absolute inset-0 flex items-center">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-[1440px] mx-auto">
            <div className="max-w-2xl">
              <div className="flex items-center gap-2 mb-4">
                <span className="px-2.5 py-0.5 text-xs font-medium bg-primary-500 text-foreground-50 rounded-full whitespace-nowrap">
                  今日推荐
                </span>
                <span className="px-2.5 py-0.5 text-xs bg-background-200/60 backdrop-blur-sm text-foreground-200 rounded-full whitespace-nowrap">
                  {featuredMovie.quality}
                </span>
              </div>
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-50 mb-3 leading-tight">
                蘑菇影视 - 高清超清免费在线观看
              </h1>
              <p className="text-sm md:text-base text-foreground-300 mb-6 max-w-lg leading-relaxed">
                {featuredMovie.description}
              </p>
              <div className="flex items-center gap-3 flex-wrap">
                <Link
                  to={`/article/${featuredMovie.id}`}
                  className="px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-foreground-50 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  <span className="flex items-center gap-2">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-play-fill text-sm"></i>
                    </div>
                    立即观看
                  </span>
                </Link>
                <Link
                  to={`/category/${featuredMovie.category}`}
                  className="px-6 py-2.5 border border-foreground-300/40 hover:border-foreground-200 text-foreground-200 hover:text-foreground-50 text-sm rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  更多{featuredMovie.category === 'movie' ? '电影' : featuredMovie.category === 'tv' ? '电视剧' : featuredMovie.category === 'anime' ? '动漫' : '综艺'}
                </Link>
              </div>

              <div className="flex items-center gap-5 mt-8">
                <div className="flex items-center gap-1.5">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-accent-500 text-sm"></i>
                  </div>
                  <span className="text-accent-400 font-semibold text-lg">{featuredMovie.rating}</span>
                </div>
                <span className="text-foreground-400 text-sm">{featuredMovie.year}</span>
                <span className="text-foreground-400 text-sm">{featuredMovie.duration}</span>
                <span className="text-foreground-400 text-sm">{featuredMovie.region}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}